<script lang="ts">
	import { HeroWithPlatformLogo } from '../HeroWithPlatformLogo';
	import type { Hero as HeroType } from '../types';

	interface Props {
		class?: string;
		hero: HeroType;
		isLive: boolean;
		alt: string | null | undefined;
		enforcedDesktopImage?: string | null;
		enforcedMobileImage?: string | null;
		disableLinks?: boolean;
		desktopImageStyle?: string;
		mobileImageStyle?: string;
	}

	let {
		hero,
		isLive,
		alt,
		enforcedDesktopImage,
		enforcedMobileImage,
		disableLinks = false,
		desktopImageStyle,
		mobileImageStyle,
		...props
	}: Props = $props();
</script>

<HeroWithPlatformLogo
	dataCy="home"
	{hero}
	{isLive}
	class="[&_a>button]:w-full {props.class}"
	{alt}
	classes={{ mobileImage: 'object-center', image: 'object-center' }}
	{enforcedDesktopImage}
	{enforcedMobileImage}
	{desktopImageStyle}
	{mobileImageStyle}
	onclick={(e) => {
		if (disableLinks && e) {
			e.preventDefault();
		}
	}}
/>
